import type * as Dialog from '@radix-ui/react-dialog'
import type * as React from 'react'
import styled from 'styled-components'
import { Drawer as DrawerPrimitive } from 'vaul'

import { ZIndex } from '../../../constants/ZIndex'

export const StyledOverlay: React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Dialog.Overlay> & React.RefAttributes<HTMLDivElement>
> = styled(DrawerPrimitive.Overlay)`
  position: fixed;
  inset: 0;
  z-index: ${ZIndex.MAX};
  background: rgba(0, 0, 0, 0.5);

  &[data-state='open'] {
    animation: fadeIn 0.2s;
  }
  &[data-state='closed'] {
    animation: fadeOut 0.2s;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`

export const StyledContent: React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Dialog.Content> & React.RefAttributes<HTMLDivElement>
> = styled(DrawerPrimitive.Content)`
  position: fixed;
  z-index: ${ZIndex.MAX};
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.colors.white.base};
  cursor: grab;

  &:focus-visible {
    outline: none;
  }

  &.vaul-dragging {
    cursor: grabbing;
  }

  &[data-vaul-drawer-direction='top'] {
    left: 0;
    right: 0;
    top: 0;
    margin-bottom: 6rem;
    max-height: 80vh;
    border-bottom: 1px solid ${props => props.theme.colors.neutral.light};
    border-radius: 0 0 ${props => props.theme.dimensions.borderRadius}
      ${props => props.theme.dimensions.borderRadius};
  }
  &[data-vaul-drawer-direction='bottom'] {
    left: 0;
    right: 0;
    bottom: 0;
    margin-top: 6rem;
    max-height: 80vh;
    border-top: 1px solid ${props => props.theme.colors.neutral.light};
    border-radius: ${props => props.theme.dimensions.borderRadius}
      ${props => props.theme.dimensions.borderRadius} 0 0;
  }
  &[data-vaul-drawer-direction='right'] {
    top: 0;
    bottom: 0;
    right: 0;
    width: 75vw;
    max-width: 24rem;
    border-left: 1px solid ${props => props.theme.colors.neutral.light};
  }
  &[data-vaul-drawer-direction='left'] {
    top: 0;
    bottom: 0;
    left: 0;
    width: 75vw;
    max-width: 24rem;
    border-right: 1px solid ${props => props.theme.colors.neutral.light};
  }

  .drawer-handle {
    display: none;
    margin: 1rem auto 0 auto;
    height: 0.5rem;
    width: 100px;
    background: ${props => props.theme.colors.neutral.light};
    border-radius: 9999px;
    &.bottom {
      display: block;
    }
  }
`
